<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">聚宝盆</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>利息列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select v-model="coinType" placeholder="请选择币种">
          <el-option value>请选择</el-option>
          <el-option
            v-for="item in projects"
            :key="item.coinType"
            :label="item.coinType"
            :value="item.coinType"
          ></el-option>
        </el-select>
        <el-select v-model="type" placeholder="奖励类型">
          <el-option value>请选择</el-option>
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="time"
          type="date"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-input placeholder="请输入用户ID" v-model="userId"></el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <span>利息发放开关</span>
        <el-switch v-model="bigSwitch" @change="changes"></el-switch>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';
import moment from 'moment';

export default {
  name: 'corocord',
  data() {
    return {
      coinType: '',
      time: moment().format('YYYY-MM-DD'),
      userId: '',
      type: '',
      bigSwitch: '',
      types: [
        { value: '1', label: '推荐人一级奖励' },
        { value: '2', label: '推荐人二级奖励' },
        { value: '3', label: '利息奖励' }
      ]
    };
  },
  components: {
    List
  },
  computed: {
    ...mapState('corocord', ['pagination']),
    ...mapState('cornucopia', ['projects'])
  },
  methods: {
    ...mapActions('corocord', ['getRecords', 'gitSwitch', 'setSwitch']),
    handleSearch() {
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      const params = {};
      if (this.coinType) {
        params.coinType = this.coinType;
      }
      if (this.time) {
        params.time = this.time;
      }
      if (this.type) {
        params.type = this.type;
      }
      if (this.userId) {
        params.userId = this.userId;
      }
      if (!this.time) {
        this.$message({
          message: '时间为必选项哦',
          type: 'error'
        });
        return;
      }
      this.getRecords({
        ...params,
        ...this.pagination,
        ...data
      });
    },
    changes() {
      this.setSwitch({ bigSwitch: this.bigSwitch }).then(() => {
        this.gitSwitch().then(res => {
          this.bigSwitch = res.data;
        });
      });
    }
  },
  mounted() {
    this.gitSwitch().then(res => {
      this.bigSwitch = res.data;
    });
    const newTime = moment().format('YYYY-MM-DD');
    this.getRecords({ time: newTime });
  }
};
</script>
